import { registerLocaleData } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouteReuseStrategy } from "@angular/router";

import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { IonicStorageModule } from "@ionic/storage-angular";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { LoadingInterceptor } from "./core/interceptors/loading.interceptor";
import { ComponentsModule } from "./shared/components/components.module";
import { HomePageModule } from "./pages/home/home.module";
import { HttpErrorInterceptor } from "./core/interceptors/http-error.interceptor";
import { HttpSuccessInterceptor } from "./core/interceptors/http-success.interceptor";
import { JwtInterceptor } from "./core/interceptors/jwt.interceptor";
import { GuidInterceptor } from "./core/interceptors/guid.interceptor";
import { OfflineInterceptor } from "./core/interceptors/offline.interceptor";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DirectivesModule } from "./shared/directives/directives.module";

registerLocaleData(localePt);

const interceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: GuidInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: JwtInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpErrorInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpSuccessInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: LoadingInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: OfflineInterceptor,
    multi: true
  },
];

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot(
      {
        mode: 'ios',
      }
    ),
    AppRoutingModule,
    ComponentsModule,
    HomePageModule,
    HttpClientModule,
    IonicStorageModule.forRoot(),
    BrowserAnimationsModule,
    DirectivesModule
  ],
  providers: [
    interceptorProviders,
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy,
    },
    {
      provide: LOCALE_ID,
      useValue: "pt-BR",
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
